import { categoriesIntro } from "@/mocks/homeContent";
import { SectionHead } from "./Common";

export default function Categories({ onPick }: { onPick: (c: string) => void }) {
  const go = (name: string) => {
    onPick(name);
    document.getElementById("featured")?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section id="categories" className="bg-background-100 py-14 md:py-20 scroll-mt-16 md:scroll-mt-20">
      <div className="container-page">
        <SectionHead
          eyebrow="Categories · 栏目分类"
          title="六大栏目，按兴趣深挖"
          desc="每个栏目都有明确的选题边界与持续更新节奏，点击任意栏目即可跳转到对应筛选内容。"
        />

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categoriesIntro.map((c) => (
            <button
              key={c.name}
              onClick={() => go(c.name)}
              className="group flex items-start gap-4 rounded-lg bg-background-50 p-5 text-left ring-1 ring-background-300/50 transition-colors hover:bg-background-200/60"
            >
              <span className="flex h-12 w-12 flex-none items-center justify-center rounded-md bg-primary-100 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={c.icon + " text-xl"}></i>
              </span>
              <span className="min-w-0">
                <span className="flex items-center justify-between gap-2">
                  <span className="font-heading text-base font-bold text-foreground-950 md:text-lg">{c.name}</span>
                  <i className="ri-arrow-right-up-line text-foreground-300 transition-colors group-hover:text-primary-500"></i>
                </span>
                <span className="mt-1 block text-sm leading-relaxed text-foreground-600">{c.desc}</span>
              </span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}